import Vue from 'vue';
import ElementUI from 'element-ui';
import VueDND from 'awe-dnd';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import './style/main.css'
import './permission'
//引入VueRouter
import VueRouter from 'vue-router'
import validator from './util/validator'
import JSEncrypt from 'jsencrypt'
import TRTC from 'trtc-js-sdk';
import vueEsign from 'vue-esign';
import jquery from "jquery";
//引入路由器
import router from './router'
import moment from 'moment';
import '@/utils/aegis.js';
import '@/assets/style/global.css';
import '@/assets/icons';
import '@/assets/style/theme/index.css'
import { Base64 } from 'js-base64'
TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.DEBUG);
Vue.use(VueRouter)
Vue.use(VueDND);
Vue.use(ElementUI);
Vue.use(vueEsign)
Vue.config.productionTip = false
Vue.prototype.$validator = validator
Vue.prototype.$moment = moment
Vue.prototype.$JSEncrypt = JSEncrypt
Vue.prototype.$ = jquery;
Vue.prototype.$Base64 = Base64
// new Vue({
//   render: h => h(App),
//   router: router
// }).$mount('#app')

new Vue({
  el: '#app',
  render: h => h(App),
  router: router
})
